// extracted by mini-css-extract-plugin
export var menuIcon = "_nj-0";
export var menuIconInline = "_nj-1";